export default __webpack_public_path__ + "static/media/Cont.89dc5b40.png";